import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { ISubscribeNewsletter } from "../interfaces/contact-api.type";
import { validateVehicle } from "../../util/vehicle/validate-vehicle";

export default function subscribeNewsletterApi(name: string, email: string, vehicle: IVehicle) {
  const params = { name, email };
  if (validateVehicle(vehicle)) {
    Object.assign(params, {
      ...vehicle,
    });
  }

  return axios.post<ISubscribeNewsletter>("/newsletter-subscribe-v3", params);
}
